module.exports = __webpack_public_path__ + "static/media/foto_2.ecab0414.png";